import React, { useEffect } from "react"
import styled, { keyframes } from "styled-components"
import {colors} from "../theme"
import {useForceBlankLinks} from "./use-force-blank-links"

const EventsWidgetWrapper = styled.div`
  max-width: 60em;
  margin: 0 auto 4em auto;
  padding: 1em;
  box-shadow: 0 0.2em 0.5em rgba(0,0,0,0.2);
  a {
    color: ${colors.mustikka};
  }
  @media (min-width: 768px) {
    padding: 2em;
  }
`

const rotate = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`

const LoadingIndicatorWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2em;
`

const LoadingIndicator = styled.span`
    width: 48px;
    height: 48px;
    border: 5px solid ${colors.pakuri};
    border-bottom-color: transparent;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: ${rotate} 1s linear infinite;
`

export default function EventsWidget({widgetId}) {
  useEffect(() => {
    if (typeof window === "undefined") return

    const scriptTagId = widgetId + "ScriptTag"

    const run = () => {
      const oldScriptTag = document.getElementById(scriptTagId)
      if (oldScriptTag) { oldScriptTag.remove() }

      const s = document.createElement("script")
      s.src = "https://tapahtumat.visitespoo.fi/widget-loader/" + widgetId
      s.async = true
      s.defer = true
      s.id = scriptTagId
      document.body.appendChild(s)
    }

    run()

    return () => {
      const el = document.getElementById("events-widget");
      if (el) el.innerHTML = "";
    }
  }, [])

  useForceBlankLinks({
    selector: '.EVENTZWIDGET a.bubster-name',
    externalOnly: true,
  });

  return (<EventsWidgetWrapper>
    <div id={'EVENTZWIDGET-' + widgetId} className='EVENTZWIDGET'>
        <LoadingIndicatorWrapper>
            <LoadingIndicator />
        </LoadingIndicatorWrapper>
    </div>
  </EventsWidgetWrapper>)
}